export default {"src":"/_next/static/media/clock-2.70de5cc8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};